/* NK i18n — version anglaise des textes écrits en dur dans les sections sur mesure.
   Chargé UNIQUEMENT quand la langue de la page est l'anglais (voir theme.liquid) :
   aucun coût pour la version française.

   • DICT : correspondance exacte (texte nettoyé des espaces) français → anglais.
   • RULES : motifs avec nombres ou dates (« 44 modèles », « lun. 28 sept. »…).
   Les noms de marques et de modèles ne sont jamais touchés ; les descriptions
   produits (déjà traduites par Translate & Adapt) ne correspondent à aucune entrée.
   Un MutationObserver traduit aussi ce qui apparaît après coup
   (tiroir panier, pack, paliers, livraison estimée…).
   Pour ajouter un texte : une ligne "français": "english" dans DICT. */
(function () {
  if (window.__nkI18n) return;
  window.__nkI18n = true;

  var DICT = {
    /* --- Bandeau défilant, bannières --- */
    "Livraison rapide en France": "Fast delivery in France",
    "Paiement sécurisé & flexible": "Secure & flexible payment",
    "Support en ligne 7j/7": "Online support 7 days a week",
    "Satisfait ou remboursé": "Satisfied or refunded",
    "Satisfait ou Remboursé": "Satisfied or Refunded",
    "SOLDES DE RENTRÉE": "BACK-TO-SCHOOL SALE",
    "-50% SUR TOUT LE MAGASIN": "-50% STORE-WIDE",
    "-25% sur la 2e paire": "-25% on your 2nd pair",
    "J'en profite": "Shop the sale",
    "+3 000 clients": "3,000+ customers",
    "L'HIVER EST LÀ": "WINTER IS HERE",
    "Doudounes et vestes : Moncler, Canada Goose, Ralph Lauren": "Puffers and jackets: Moncler, Canada Goose, Ralph Lauren",
    "Découvrir": "Discover",
    "Bannière 1": "Banner 1",
    "Bannière 2": "Banner 2",
    "Précédent": "Previous",
    "Suivant": "Next",

    /* --- Accueil --- */
    "Nos sneakers": "Our sneakers",
    "Voir plus": "See more",
    "Nouveautés bientôt disponibles.": "New arrivals coming soon.",
    "Nos best-sellers": "Our best-sellers",
    "Tout afficher": "View all",
    "Nos collections": "Our collections",
    "Chaussures": "Shoes",
    "Doudounes & Vestes": "Puffers & Jackets",
    "Vêtements": "Clothing",
    "Validé par nos ambassadeurs": "Approved by our ambassadors",
    "Ils partagent leur expérience": "They share their experience",
    "Couper ou remettre le son": "Mute or unmute",
    "À l'affiche": "Featured",
    "Une saison, un style": "One season, one style",
    "À chaque saison sa collection": "A collection for every season",
    "Saison froide": "Cold season",
    "Prêts pour l'hiver": "Ready for winter",
    "Doudounes Moncler, Canada Goose, Ralph Lauren et CP Company. Le chaud qui ne sacrifie rien au style.": "Moncler, Canada Goose, Ralph Lauren and CP Company puffers. Warmth without compromising on style.",
    "Voir les doudounes": "Shop puffers",
    "Entre deux saisons": "In-between seasons",
    "La veste qui fait la tenue": "The jacket that makes the outfit",
    "Supreme, Courrèges, Ami Paris : les pièces légères qui portent tout le reste.": "Supreme, Courrèges, Ami Paris: the lightweight pieces that carry the whole look.",
    "Voir les vestes": "Shop jackets",
    "Notre histoire": "Our story",
    "LA CULTURE SNEAKER, SANS COMPROMIS": "SNEAKER CULTURE, NO COMPROMISE",
    "Des icônes d'hier aux drops d'aujourd'hui, chaque paire est sélectionnée à la main. Pas de remplissage — juste des pépites qu'on porterait nous-mêmes.": "From yesterday's icons to today's drops, every pair is hand-picked. No filler — just gems we'd wear ourselves.",
    "Voir tout le catalogue": "Shop the full catalogue",
    "Nos marques": "Our brands",
    "Découvrir la collection": "Discover the collection",
    "Depuis le premier drop": "Since the very first drop",
    "La culture sneaker, sans compromis.": "Sneaker culture, no compromise.",
    "Rejoins le Kicklab": "Join the Kicklab",
    "Crée ton compte pour suivre tes commandes, accéder aux drops en avant-première et ne rien rater des nouveautés.": "Create your account to track your orders, get early access to drops and never miss a new arrival.",
    "Créer un compte": "Create an account",
    "Se connecter": "Log in",
    "Ne rate pas ça": "Don't miss this",
    "La collab du moment": "The collab of the moment",
    "L'icône": "The icon",
    "Acheter": "Shop",

    /* --- Avis clients --- */
    "La voix de nos clients !": "What our customers say!",
    "Basé sur 512 avis clients": "Based on 512 customer reviews",
    "Client Urban Kicklab": "Urban Kicklab customer",
    "Achat vérifié": "Verified purchase",
    "Avis client Urban Kicklab": "Urban Kicklab customer review",
    "Commandé un lundi, reçu le mercredi. La paire est nickel, aucune trace, boîte impeccable.": "Ordered on Monday, received on Wednesday. The pair is spotless, not a mark, box in perfect condition.",
    "Je cherchais ce modèle depuis des mois, introuvable ailleurs à ce prix. Merci !": "I'd been looking for this model for months, impossible to find elsewhere at this price. Thank you!",
    "Taille parfaitement, j'ai pris ma pointure habituelle sans hésiter.": "Fits perfectly, I took my usual size without hesitating.",
    "Taille parfaitement, j’ai pris ma pointure habituelle sans hésiter.": "Fits perfectly, I took my usual size without hesitating.",
    "Le SAV répond en quelques minutes, ça change tout quand on hésite sur la taille.": "Customer service replies within minutes — a game changer when you're unsure about the size.",
    "Deuxième commande, toujours la même qualité. Je ne vais plus voir ailleurs.": "Second order, same quality every time. I won't shop anywhere else.",
    "Emballage soigné et petit mot dans le colis, ça fait plaisir.": "Careful packaging and a little note in the parcel — lovely touch.",
    "Au prix payé je m'attendais à moins bien. Très agréablement surpris.": "For the price I expected less. Very pleasantly surprised.",
    "Au prix payé je m’attendais à moins bien. Très agréablement surpris.": "For the price I expected less. Very pleasantly surprised.",
    "Offerte à mon copain, il ne les quitte plus. Mission réussie.": "A gift for my boyfriend, he never takes them off. Mission accomplished.",
    "Livraison suivie à chaque étape, aucune mauvaise surprise.": "Delivery tracked every step of the way, no bad surprises.",
    "Les photos du site sont fidèles, la couleur est exactement la même en vrai.": "The website photos are accurate, the colour is exactly the same in real life.",
    "Confortables dès le premier jour, zéro temps d'adaptation.": "Comfortable from day one, no break-in time.",
    "Confortables dès le premier jour, zéro temps d’adaptation.": "Comfortable from day one, no break-in time.",
    "Site sérieux, paiement en plusieurs fois bien pratique. Je recommande.": "Trustworthy site, paying in instalments is really handy. I recommend it.",
    "Vos Retours": "Your feedback",
    "Vos retours": "Your feedback",

    /* --- Fiche produit --- */
    "Guide des tailles": "Size guide",
    "Nos modèles chaussent normalement.": "Our models fit true to size.",
    "Prends ta pointure habituelle.": "Take your usual size.",
    "Prends la taille au-dessus.": "Take one size up.",
    "Comment mesurer ton pied :": "How to measure your foot:",
    "pose ton talon contre un mur, debout, et mesure jusqu'au bout de ton orteil le plus long.": "stand with your heel against a wall and measure to the tip of your longest toe.",
    "Mesure en fin de journée : le pied est légèrement plus large qu'au réveil.": "Measure at the end of the day: your foot is slightly wider than in the morning.",
    "Correspondances indicatives, variables selon les marques.": "Conversions are a guide and may vary by brand.",
    "Pointure": "Size",
    "Taille": "Size",
    "Taille:": "Size:",
    "Taille :": "Size:",
    "2ème paire à -25% + kit offerts avec le code URBAN25": "2nd pair -25% + free kit with code URBAN25",
    "avis": "reviews",
    "Livraison": "Delivery",
    "Commande": "Order",
    "Préparation": "Processing",
    "Expédition": "Shipping",
    "Livraison Offerte": "Free Delivery",
    "Livraison offerte": "Free delivery",
    "Retour sous 30 jours": "30-day returns",
    "0 % d'intérêts": "0% interest",
    "0 % d’intérêts": "0% interest",
    "Paiement sécurisé": "Secure payment",
    "Commandé": "Ordered",
    "Expédié": "Shipped",
    "Livré": "Delivered",
    "Livraison estimée entre le": "Estimated delivery between",
    "et le": "and",
    "Commande maintenant : expédition": "Order now: ships",
    "Commande dans les": "Order within",
    ": expédition": ": ships",
    "aujourd'hui": "today",
    "aujourd’hui": "today",
    "demain": "tomorrow",
    "lundi": "Monday", "mardi": "Tuesday", "mercredi": "Wednesday", "jeudi": "Thursday", "vendredi": "Friday", "samedi": "Saturday", "dimanche": "Sunday",
    "Livraison & Retour Gratuit": "Free Delivery & Returns",
    "Les commandes sont expédiées sous 24 à 72 h. La livraison est ensuite estimée entre 8 et 12 jours après la commande.": "Orders ship within 24 to 72 hours. Delivery is then estimated at 8 to 12 days after ordering.",
    "Le délai total correspond au temps de préparation de votre commande ainsi qu’au temps d’acheminement.": "The total lead time includes order processing and transit time.",
    "Le délai total correspond au temps de préparation de votre commande ainsi qu'au temps d'acheminement.": "The total lead time includes order processing and transit time.",
    "À noter : durant les périodes de fêtes": "Please note: during holiday periods",
    "de forte affluence, des retards exceptionnels peuvent survenir.": "and peak times, exceptional delays may occur.",
    "Pas entièrement satisfait ? Vous disposez de 30 jours après réception pour effectuer un retour. Une fois votre article reçu et vérifié, le remboursement est effectué rapidement via votre moyen de paiement initial.": "Not completely satisfied? You have 30 days after delivery to return your item. Once it has been received and checked, you are refunded promptly to your original payment method.",
    "RÉSEAUX SOCIAUX": "SOCIAL MEDIA",
    "Nos produits en vidéo": "Our products on video",
    "Vrais clients, vraies réactions": "Real customers, real reactions",
    "Vus et portés par notre communauté": "Seen and worn by our community",
    "Voir le produit": "View product",
    "Voir la collection": "View collection",
    "Lire la vidéo": "Play video",
    "Doudounes Moncler": "Moncler Puffers",
    "Doudounes Moncler (unboxing)": "Moncler Puffers (unboxing)",
    "Vestes Supreme": "Supreme Jackets",
    "Vestes Courrèges": "Courrèges Jackets",
    "Les marques disponibles sur le site": "Brands available on our site",
    "Les marques disponibles sur Urban Kicklab": "Brands available at Urban Kicklab",
    "AFFICHER PLUS": "SHOW MORE",
    "Récemment consultés": "Recently viewed",
    "Articles Consultés Récemment": "Recently Viewed Items",
    "Vous allez aimer": "You'll love",
    "Photo précédente": "Previous photo",
    "Photo suivante": "Next photo",

    /* --- FAQ, confiance --- */
    "On vous répond en toute clarté": "Clear answers to your questions",
    "Questions fréquentes": "Frequently asked questions",
    "Quels sont les délais de livraison ?": "How long does delivery take?",
    "Ta commande est expédiée sous 24 à 72 h, puis livrée en 8 à 12 jours. Tu reçois un numéro de suivi par e-mail dès l'expédition pour suivre ton colis à chaque étape.": "Your order ships within 24 to 72 hours, then arrives in 8 to 12 days. You'll receive a tracking number by email as soon as it ships, so you can follow your parcel every step of the way.",
    "Le paiement est-il sécurisé ?": "Is payment secure?",
    "À 100 %. Paiement crypté via les principales cartes bancaires et solutions de paiement. Tes données bancaires ne sont jamais conservées.": "100%. Encrypted payment through all major cards and payment methods. Your card details are never stored.",
    "Et si la paire ne me convient pas ?": "What if the pair isn't right for me?",
    "Garantie satisfait ou remboursé : contacte notre service client, on organise l'échange de taille ou le remboursement. Tu commandes l'esprit tranquille.": "Satisfaction guaranteed: contact our customer service and we'll arrange a size exchange or a refund. Order with peace of mind.",
    "Comment contacter le service client ?": "How do I contact customer service?",
    "Notre équipe est réactive et répond rapidement à toutes tes questions — avant comme après ta commande.": "Our team is responsive and answers all your questions quickly — before and after your order.",
    "Commande en toute confiance": "Order with confidence",
    "Expédition 24-48 h": "Ships in 24-48 h",
    "Expédition 24-72 h": "Ships in 24-72 h",
    "Commande expédiée rapidement, suivi inclus.": "Fast shipping, tracking included.",
    "Transactions 100 % cryptées.": "100% encrypted transactions.",
    "Échange ou remboursement, sans prise de tête.": "Hassle-free exchanges or refunds.",
    "Service client réactif": "Responsive customer service",
    "Une question ? On te répond vite.": "A question? We'll get back to you fast.",
    "Les plus regardés en ce moment": "Most viewed right now",
    "Sélection basée sur les pages les plus visitées": "Selection based on our most visited pages",
    "Tout voir": "View all",

    /* --- Pied de page, newsletter, pop-up --- */
    "Soyez les premiers à être au courant de nos promotions !": "Be the first to hear about our deals!",
    "Entrez votre email": "Enter your email",
    "À Propos": "About",
    "Contacter le SAV sur WhatsApp": "Contact customer service on WhatsApp",
    "Offre de bienvenue": "Welcome offer",
    "-10 % supplémentaire sur ta 1re commande": "An extra 10% off your first order",
    "À cumuler avec les soldes. Code à saisir au moment du paiement.": "Stacks with the sale. Enter the code at checkout.",
    "Copier le code": "Copy code",
    "Code copié": "Code copied",
    "Code :": "Code:",
    "Non merci": "No thanks",
    "Fermer": "Close",

    /* --- Panier --- */
    "Panier": "Cart",
    "Ton panier est vide.": "Your cart is empty.",
    "Fermer le panier": "Close cart",
    "-10% avec le code": "10% off with code",
    "sur votre première commande": "on your first order",
    "1 PAIRE ACHETÉE LA DEUXIÈME À -25% !": "BUY 1 PAIR, GET THE SECOND -25%!",
    "Plus que": "Only",
    "1 paire": "1 more pair",
    "2 paires": "2 pairs",
    "3 paires": "3 pairs",
    "pour débloquer": "to unlock",
    "Tous tes avantages sont débloqués.": "All your perks are unlocked.",
    "Offre pack": "Bundle offer",
    "COMPLÈTE TON PACK": "COMPLETE YOUR BUNDLE",
    "2e paire à -25%": "2nd pair -25%",
    "3e paire : chaussettes + kit": "3rd pair: socks + kit",
    "Choisis ta 2e paire": "Choose your 2nd pair",
    "Choisis ta 3e paire": "Choose your 3rd pair",
    "Choisis un modèle et une taille": "Choose a model and a size",
    "Choisir la taille": "Choose size",
    "Ou cherche un autre modèle…": "Or search for another model…",
    "+ cadeau offert dès 139 €": "+ free gift from €139",
    "Remise -25% appliquée automatiquement au panier sur la paire la moins chère. Cumulable avec les paliers de fidélité.": "The -25% discount is applied automatically at checkout to the cheaper pair. Stacks with loyalty tiers.",
    "Livraison offerte, expédition sous 24 à 72 h.": "Free delivery, ships within 24 to 72 hours.",
    "Chaussettes ou kit offert": "Free socks or kit",
    "Chaussettes + kit offerts": "Free socks + kit",
    "Kit offert + tes chaussettes au choix": "Free kit + socks of your choice",
    "Choisis ta taille pour recevoir tes chaussettes": "Choose your size to get your socks",
    "Ton cadeau au choix": "Your free gift",
    "Panier réservé pendant": "Cart reserved for",
    "Payez en": "Pay in",
    "3 ou 4 fois": "3 or 4 instalments",
    "avec Klarna": "with Klarna",
    "Paiement 100 % sécurisé": "100% secure payment",
    "Code promo": "Promo code",
    "Entre ton code promo": "Enter your promo code",
    "Appliquer": "Apply",
    "Annuler": "Cancel",
    "Sous-total": "Subtotal",
    "Commander": "Checkout",
    "Enlever": "Remove",
    "Offert": "Free",
    "Kit KICK CARE — Offert": "KICK CARE kit — Free",
    "Chaussettes Nike — Offertes": "Nike socks — Free",
    "Réduire ou étendre le bas du panier": "Collapse or expand the cart footer",
    "Voir ou masquer les avantages et le pack": "Show or hide perks and bundle",
    "Voir le panier": "View cart"
  };

  var DAYS = { 'dim.': 'Sun', 'lun.': 'Mon', 'mar.': 'Tue', 'mer.': 'Wed', 'jeu.': 'Thu', 'ven.': 'Fri', 'sam.': 'Sat' };
  var MONTHS = { 'janv.': 'Jan', 'févr.': 'Feb', 'mars': 'Mar', 'avr.': 'Apr', 'mai': 'May', 'juin': 'Jun', 'juil.': 'Jul', 'août': 'Aug', 'sept.': 'Sep', 'oct.': 'Oct', 'nov.': 'Nov', 'déc.': 'Dec' };

  var RULES = [
    [/^(\d+) modèles?$/, function (m, n) { return n + (n === '1' ? ' model' : ' models'); }],
    [/^• (\d+) avis$/, function (m, n) { return '• ' + n + ' reviews'; }],
    [/^(\d+) avis$/, function (m, n) { return n + ' reviews'; }],
    [/^Vous Économisez (.+)$/i, function (m, v) { return 'You save ' + v; }],
    [/^Noté (.+)$/, function (m, v) { return 'Rated ' + v; }],
    [/^J\+(\d+) à J\+(\d+)$/, function (m, a, b) { return 'Day ' + a + ' to ' + b; }],
    [/^(\d+) paires$/, function (m, n) { return n + ' pairs'; }],
    /* Dates courtes : « lun. 28 sept. », « lun. 28 – mer. 30 sept. » */
    [/(dim\.|lun\.|mar\.|mer\.|jeu\.|ven\.|sam\.)/g, function (m) { return DAYS[m]; }, true],
    [/\b(janv\.|févr\.|mars|avr\.|mai|juin|juil\.|août|sept\.|oct\.|nov\.|déc\.)(?=\s|$)/g, function (m) { return MONTHS[m]; }, true],
    [/(\d+) h (\d+) min/g, function (m, h, mi) { return h + 'h ' + mi + 'min'; }, true]
  ];

  function tr(raw) {
    var t = raw.replace(/\s+/g, ' ').trim();
    if (!t) return null;
    if (Object.prototype.hasOwnProperty.call(DICT, t)) return DICT[t];
    var out = t, changed = false;
    for (var i = 0; i < RULES.length; i++) {
      var r = RULES[i];
      if (r[2]) {
        var nx = out.replace(r[0], r[1]);
        if (nx !== out) { out = nx; changed = true; }
      } else if (r[0].test(out)) {
        out = out.replace(r[0], r[1]); changed = true; break;
      }
    }
    return changed ? out : null;
  }

  /* Descriptions produits exclues (déjà traduites par Translate & Adapt) */
  var SKIP = 'script,style,noscript,textarea,code,pre,[contenteditable],.product__description,.sf-product-description,[data-nk-noi18n]';
  function doText(node) {
    var p = node.parentElement;
    if (!p || p.closest(SKIP)) return;
    var v = node.nodeValue;
    var res = tr(v);
    if (res === null) return;
    var lead = v.match(/^\s*/)[0], trail = v.match(/\s*$/)[0];
    var next = lead + res + trail;
    if (next !== v) node.nodeValue = next;
  }
  var ATTRS = ['placeholder', 'aria-label', 'title'];
  function doAttrs(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute && el.getAttribute(ATTRS[i]);
      if (!v) continue;
      var res = tr(v);
      if (res !== null && res !== v) el.setAttribute(ATTRS[i], res);
    }
    if (el.tagName === 'INPUT' && /^(submit|button)$/i.test(el.type) && el.value) {
      var rv = tr(el.value); if (rv !== null) el.value = rv;
    }
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { doText(root); return; }
    if (root.nodeType !== 1 || root.closest && root.closest(SKIP)) return;
    doAttrs(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeType === 3) doText(n); else doAttrs(n);
    }
  }

  var busy = false;
  function observe() {
    new MutationObserver(function (list) {
      if (busy) return;
      busy = true;
      try {
        for (var i = 0; i < list.length; i++) {
          var m = list[i];
          if (m.type === 'characterData') doText(m.target);
          else if (m.type === 'attributes') doAttrs(m.target);
          else for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
        }
      } finally { busy = false; }
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }

  function boot() { walk(document.body); observe(); document.documentElement.classList.add('nk-i18n-ready'); }
  if (document.body) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
